import { ExcludedPlatforms } from 'app/types/excludedPlatforms'
import { gql } from 'graphql-request'
import { GenericBlock } from './generic'

export const merchCollectiblesCallToActionFragment = gql`
  fragment merchCollectiblesCallToActionFragment on MerchCollectiblesCallToAction {
    id
    merchCollectiblesTitle: title
    merchCollectiblesCtaLabel: ctaLabel
    merchCollectiblesCtaHref: ctaHref
    excludedPlatforms {
      ios
      android
      web
    }
  }
`

export interface MerchCollectiblesCallToAction
  extends GenericBlock<'MerchCollectiblesCallToAction'> {
  title: string
  ctaLabel: string
  ctaHref: string
  excludedPlatforms?: ExcludedPlatforms
}
